import React from 'react';
import { renderWhatsAppText } from './renderWhatsAppText';
import { FENCE } from '../../../../../../../../store/globalAskAica/whatsapp/constants';
import styles from './WhatsAppChat.module.scss';

/** Pairs ``` fences left to right: each closed pair is a code block; a trailing unclosed fence stays literal text. */
const splitFences = (text: string): { code: boolean; value: string }[] => {
    const parts = text.split(FENCE);
    const hasTrailingUnclosed = parts.length % 2 === 0;
    const closedCount = hasTrailingUnclosed ? parts.length - 1 : parts.length;
    const segments = parts.slice(0, closedCount).map((value, i) => ({ code: i % 2 === 1, value }));
    if (hasTrailingUnclosed) {
        // Re-attach the dangling fence and everything after it to the last text segment.
        const tail = `${FENCE}${parts[parts.length - 1]}`;
        const last = segments[segments.length - 1];
        segments[segments.length - 1] = { code: false, value: `${last.value}${tail}` };
    }
    return segments.filter((p) => p.value !== '');
};

/**
 * A WhatsApp message body as WhatsApp shows it: ``` fences as a block, inline marks only at
 * word boundaries, every line kept, no markdown and no HTML parsing (the text is untrusted).
 */
const WhatsAppMessageText: React.FC<{ text: string }> = ({ text }) => (
    <div className={styles.MessageText}>
        {splitFences(text).map((part, i) =>
            part.code ? (
                <pre key={i} className={styles.CodeBlock}>
                    {part.value.replace(/^\n/, '').replace(/\n$/, '')}
                </pre>
            ) : (
                <React.Fragment key={i}>{renderWhatsAppText(part.value)}</React.Fragment>
            ),
        )}
    </div>
);

export default WhatsAppMessageText;
